function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { ItemTypeConnect } from '@square/dashboard-items-data/utils/item-type-constants';
export default class Item extends CatalogObjectSerializer.extend(EmbeddedRecordsMixin) {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "attrs", {
      variations: {
        embedded: 'always',
        serializedOnFragment: 'item_data'
      },
      event: {
        embedded: 'always',
        serializedOnFragment: 'item_data'
      },
      images: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'item_data',
        serializedOnKey: 'image_ids'
      },
      taxes: {
        serialize: 'ids',
        deserialize: 'ids',
        serializedOnFragment: 'item_data',
        serializedOnKey: 'tax_ids'
      }
    });
  }
  normalize(type, item) {
    // TODO: [can] Ember data is not updating categories when the backend responds back without
    // the categories key. I'm not sure this occurs with other keys. If it does, we should implement
    // a smarter logic like here https://github.com/squareup/dashboard/blob/587ff6ae5e1e50aea8af870c504357dbe3366f6e/frontend/%40square/dashboard-items-data/addon/serializers/items-v3-base.js#L57
    if (item.item_data) {
      item.item_data.categories = item.item_data.categories ?? [];
      item.item_data.reporting_category = item.item_data.reporting_category ?? null;
      item.item_data.channels = item.item_data.channels ?? [];
      this.normalizeFoodAndBev(type, item);
    }
    return super.normalize(type, item);
  }

  // Ember data fragments don't clear the existing stale data corresponding to key that the back-end omits.
  // This function ensures that the state of item_data.food_and_beverage_details is always predictable and matches.
  // server state
  normalizeFoodAndBev(type, item) {
    if (item.item_data.product_type !== ItemTypeConnect.FOOD_AND_BEV) {
      item.item_data.food_and_beverage_details = null;
      return;
    }
    if (!item.item_data.food_and_beverage_details) {
      item.item_data.food_and_beverage_details = {
        calorie_count: null,
        dietary_preferences: [],
        ingredients: []
      };
      return;
    }
    item.item_data.food_and_beverage_details.calorie_count ??= null;
    item.item_data.food_and_beverage_details.dietary_preferences ??= [];
    item.item_data.food_and_beverage_details.ingredients ??= [];
  }
}